import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IAuditComponent, IAuditModel, IAuditPanelInfo } from '@shared/models/audit.model';
import { Breadcrumb } from '@types-custom/models/ui/breadcrumb-model';
import { Icon } from '@types-custom/models/ui/icon-model';

@Component({
  selector: 'panel-audit-info',
  templateUrl: './panel-audit-info.component.html',
  styleUrls: ['./panel-audit-info.component.scss'],
})
export class PanelAuditInfoComponent implements OnInit {

  @Input() properties: IAuditPanelInfo;
  @Input() breadcrumbs: Breadcrumb[];
  @Output() handleValue = new EventEmitter<any>();

  Icon = Icon;
  icon = Icon.manage_accounts_w;

  ngOnInit(): void {
    this.breadcrumbs.push({
      label: 'Detalle registro',
      url: IAuditComponent.PANEL_AUDIT_INFO
    });
  }

  navigateLast(component: string): void {
    // validar a donde regresa y remover las rutas 
    // cambiar url por component
    // hacer un case
    if(component == IAuditComponent.GRID_AUDIT_USER) {
      // Quitar el ultimo 
      this.breadcrumbs.splice(this.breadcrumbs.length - 1, 1);
      const modelAudit: IAuditModel = {
        code: this.properties.model.code,
        renderGridUser: true,
        routes: this.breadcrumbs
      };
      this.handleValue.emit(modelAudit);
    }

    if(component == IAuditComponent.GRID_AUDIT_RECORD) {
      // Quitar el ultimo 
      this.breadcrumbs.splice(this.breadcrumbs.length - 1, 1);
      const modelAudit: IAuditModel = {
        code: this.properties.model.code,
        renderGridRecord: true,
        routes: this.breadcrumbs
      };
      this.handleValue.emit(modelAudit);
    }

    if(component == IAuditComponent.PRINCIPAL) {
      // Quitar el ultimo 
      this.breadcrumbs.splice(this.breadcrumbs.length - 2, 1);
      const modelAudit: IAuditModel = {
        code: this.properties.model.code,
        renderPrincipal: true,
        routes: this.breadcrumbs
      };
      this.handleValue.emit(modelAudit);
    }
  }

  navigateToVisor(): void {
    // this.router.navigate([RouteNamesEnum.MapViewer]);
  }
}
